import "./InfoViewerElement-style";

class InfoViewerElement extends HTMLElement {
    connectedCallback() {   }
}
customElements.define("info-viewer", InfoViewerElement);


